import { render, staticRenderFns } from "./b-popup-choose-mu-ban.vue?vue&type=template&id=4950e6cf&scoped=true"
import script from "./b-popup-choose-mu-ban.vue?vue&type=script&lang=js"
export * from "./b-popup-choose-mu-ban.vue?vue&type=script&lang=js"
import style0 from "./b-popup-choose-mu-ban.vue?vue&type=style&index=0&id=4950e6cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4950e6cf",
  null
  
)

export default component.exports